import { createRoot } from 'react-dom/client';
import React from 'react';
import CustomAlert from '../components/CustomAlert';

let alertContainer = null;
let alertRoot = null;

const createAlertContainer = () => {
  if (!alertContainer) {
    alertContainer = document.createElement('div');
    alertContainer.id = 'custom-alert-container';
    document.body.appendChild(alertContainer);
    alertRoot = createRoot(alertContainer);
  }
};

const showCustomAlert = ({
  title = '提示',
  message,
  type = 'info',
  confirmText = '确定',
  showCancel = false,
  cancelText = '取消',
  onConfirm,
  onCancel
}) => {
  createAlertContainer();

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
    // 添加安全检查
    if (alertRoot) {
      try {
        alertRoot.unmount();
      } catch (error) {
        console.warn('Alert unmount error:', error);
      }
    }
    if (alertContainer) {
      alertContainer.remove();
    }
    alertContainer = null;
    alertRoot = null;
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };

  // 添加安全检查
  if (alertRoot) {
    try {
      alertRoot.render(
        <CustomAlert
          visible={true}
          onClose={handleClose}
          title={title}
          message={message}
          type={type}
          confirmText={confirmText}
          showCancel={showCancel}
          cancelText={cancelText}
          onConfirm={handleConfirm}
        />
      );
    } catch (error) {
      console.error('Alert render error:', error);
      // 清理状态
      if (alertContainer) {
        alertContainer.remove();
      }
      alertContainer = null;
      alertRoot = null;
    }
  }
};

// 便捷方法
export const showSuccessAlert = (message, title = '成功') => {
  showCustomAlert({
    title,
    message,
    type: 'success'
  });
};

export const showErrorAlert = (message, title = '错误', onConfirm) => {
  showCustomAlert({
    title,
    message,
    type: 'error',
    onConfirm
  });
};

export const showSecurityAlert = (message, title = '安全提示', onConfirm) => {
  showCustomAlert({
    title,
    message,
    type: 'security',
    onConfirm
  });
};

export const showAuthAlert = (message, title = '认证失败', onConfirm) => {
  showCustomAlert({
    title,
    message,
    type: 'auth',
    onConfirm
  });
};

export const showWarningAlert = (message, title = '警告') => {
  showCustomAlert({
    title,
    message,
    type: 'warning'
  });
};

export const showInfoAlert = (message, title = '提示') => {
  showCustomAlert({
    title,
    message,
    type: 'info'
  });
};

export const showConfirmAlert = (message, title = '确认', onConfirm, onCancel) => {
  showCustomAlert({
    title,
    message,
    type: 'warning',
    showCancel: true,
    onConfirm,
    onCancel
  });
};

export default showCustomAlert; 